import { MapGeoJSONFeature } from "maplibre-gl";
import { Feature, Geometry } from "geojson";

import {
  CIRCE_RADIUS_SOURCE_ID,
  COUNTRY_SOURCE_ID,
  ROUTING_SOURCE_ID
} from "@/constants/map";
import { SelectedFeature } from "@/types/map";

// At the top of the file
const NON_CLICKABLE_SOURCES = [
  COUNTRY_SOURCE_ID,
  CIRCE_RADIUS_SOURCE_ID,
  ROUTING_SOURCE_ID
] as const;

interface MapFeature extends Feature<Geometry> {
  source?: string;
  id?: string | number;
}

// Helper: Generate consistent feature identifier
export const createFeatureId = (source?: string, id?: string | number) =>
  `${source}-${id}`;

// Helper: Check if feature is a base layer (non-clickable)
export const isBaseLayerFeature = (feature: MapGeoJSONFeature) => {
  return NON_CLICKABLE_SOURCES.some((sourceId) =>
    feature.layer.id.includes(sourceId)
  );
};

// Helper: Find the first clickable feature
export const findClickableFeature = (features: MapGeoJSONFeature[]) => {
  return features.find((feature) => !isBaseLayerFeature(feature));
};

// Helper: Check if feature is already selected
export const isFeatureAlreadyActive = (
  feature: MapFeature,
  currentSelection: SelectedFeature | null,
  comparisonFeatures: SelectedFeature[]
) => {
  const featureId = createFeatureId(feature.source, feature.id);
  const selectedId = createFeatureId(
    currentSelection?.source,
    currentSelection?.id
  );

  return (
    featureId === selectedId ||
    comparisonFeatures.some((f) => f.id === feature.id)
  );
};
